export default __webpack_public_path__ + "static/media/step7.5701e6cb.png";